<template>
  <div class="flex h-full flex-col justify-between">
    <!-- <TopBar
      v-if="appStore.topBar.show"
      class="mb-20"
      :show-back-button="appStore.topBar.showBackButton"
      :show-toggle="appStore.topBar.showToggle"
    /> -->
    <router-view
      class="flex flex-col p-4"
      :style="{
        height: layoutHeight,
        overflowY: 'auto'
      }"
      :key="$route.path"
    />

    <BottomNavBar
      v-if="showNavBar"
      :callback-scan="handleReadProductClick"
      :callback-history="handleHistoryClick"
      :disable-history="isShipping"
      :key="bottomNavBar"
    />

    <HiddenActionButton v-model="input" :show-debug-text="config.debug.showHiddenInputDegubText" />

    <HiddenSoundPlayer />
  </div>
</template>

<script setup lang="ts">
import BottomNavBar from '@/components/BottomNavBar/BottomNavBar.vue'
import HiddenSoundPlayer from '@/components/HiddenSoundPlayer/HiddenSoundPlayer.vue'
// import TopBar from '@/components/TopBar/TopBar.vue'
import { BOTTOM_NAVBAR_HEIGHT } from '@/constraints'
import { config } from '@/default'
import { HiddenInput } from '@/helpers/symbols'
import { useAppStore } from '@/stores/app.store'
import HiddenActionButton from '@components/HiddenActionInput/HiddenActionInput.vue'
import { computed, provide, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { OperationType, useUserStore } from '@/stores/user.store'

const route = useRoute()
const router = useRouter()
const input = ref('')
const appStore = useAppStore()
const userStore = useUserStore()
const bottomNavBar = ref(0)
const isShipping = computed(
  () =>
    userStore.decodedToken?.productionSequenceOperation.operation.type === OperationType.SHIPPING
)

provide(HiddenInput, input)

// Determine if the NavBar should be shown based on the route meta
const showNavBar = computed(() => {
  return route.meta.showNavBar === true
})

const layoutHeight = computed(() => {
  return `calc(100% - ${showNavBar.value ? BOTTOM_NAVBAR_HEIGHT : 0}px)`
})

async function handleReadProductClick() {
  appStore.actions.setCurrentPage('read_product')
  bottomNavBar.value = (bottomNavBar.value + 1) % 3
  console.log(bottomNavBar.value)
  router.push('/')
}

async function handleHistoryClick() {
  appStore.actions.setCurrentPage('history')
  bottomNavBar.value = (bottomNavBar.value + 1) % 3
  router.push({ name: 'history' })
}
</script>
